import { AUDIT_ACTION_BADGE_STYLES, AUDIT_ACTION_GROUPS } from "@/constant/organization.constant";

export function humanizeAuditAction(action: string): string {
  return action.replace(/[._]/g, " ");
}

// The category name shown on the row's badge ("Deals", "Security", …).
export function getAuditActionCategory(action: string): string {
  const prefix = action.split(/[._]/)[0] + ".";
  return AUDIT_ACTION_GROUPS.find((g) => g.key === prefix)?.label || "Activity";
}

export function getAuditActionBadgeClass(action: string): string {
  const key = action.split(/[._]/)[0] as keyof typeof AUDIT_ACTION_BADGE_STYLES;
  return AUDIT_ACTION_BADGE_STYLES[key] || AUDIT_ACTION_BADGE_STYLES.default;
}
